import React, { useState } from 'react'
import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Input,
  Link,
  Text,
} from '@workwhile/ui'
import { Header } from 'components/Header'
import * as ROUTES from 'constants/routes'

type ShiftIdEntryProps = {
  onSubmit: (shiftId: number) => void
}

export const ShiftIdEntry = ({ onSubmit }: ShiftIdEntryProps) => {
  const [input, setInput] = useState('')
  const parsed = Number(input)
  const isValid = input.trim() !== '' && Number.isInteger(parsed) && parsed > 0

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (isValid) onSubmit(parsed)
  }

  return (
    <>
      <Header
        title={
          <Flex alignItems="flex-start" gap={2} flexDirection="column">
            <Text
              as={Link}
              color="lightText"
              style={{ textTransform: 'uppercase' }}
              to={ROUTES.PLAYGROUND}
              fontSize={0}
            >
              Playground
            </Text>
            <Heading level={1} style={{ margin: 0 }} fontWeight="400">
              Assessments
            </Heading>
          </Flex>
        }
      />
      <Box margin={3} maxWidth="32rem">
        <form onSubmit={handleSubmit}>
          <Flex flexDirection="column" gap={3}>
            <Field label="Shift ID">
              <Input
                block
                type="number"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Enter a shift ID"
                autoFocus
              />
            </Field>
            <Flex>
              <Button
                type="submit"
                variant="primary"
                kind="medium"
                disabled={!isValid}
              >
                Continue
              </Button>
            </Flex>
          </Flex>
        </form>
      </Box>
    </>
  )
}
